import React from "react";
import ReactDOMServer from "react-dom/server";
import { formatDate } from "./BnplFreezePDFUtils";

export default function BnplFreezePDFHeaderStatic({ freeze, flight, detail }) {
  const status = freeze?.status || flight?.priceFreezeStatus || "-";
  const ticketStatus = flight?.status || "-";
  const outstanding = Number(detail?.remainingAmount);
  const paymentStatus =
    outstanding === 0 || String(status).toUpperCase() === "FULLYPAID"
      ? "PAID"
      : "OUTSTANDING";
  const paymentTone =
    paymentStatus === "PAID"
      ? "bg-green-50 text-green-800 border-green-200"
      : "bg-yellow-50 text-yellow-800 border-yellow-200";

  const content = (
    <table className="w-full mb-6" cellPadding="0" cellSpacing="0">
      <tbody>
        <tr>
          <td className="pb-3 border-b-2 border-gray-800">
            <table className="w-full" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td className="align-top">
                    <div className="text-xs font-bold tracking-widest text-gray-500 uppercase">
                      Intraverse
                    </div>
                    <div className="text-2xl font-extrabold text-gray-900 leading-tight mt-1">
                      BNPL Flight Order
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      Price Freeze / Buy Now Pay Later report
                    </div>
                  </td>
                  <td className="align-top text-right" style={{ width: "42%" }}>
                    <table
                      className="w-full text-xs border border-gray-200"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <tbody>
                        <tr className="bg-gray-50">
                          <td className="px-2 py-1.5 text-gray-500 border-b border-gray-200">
                            Reference
                          </td>
                          <td className="px-2 py-1.5 font-bold text-gray-800 border-b border-gray-200 text-right">
                            {freeze?.reference || "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-2 py-1.5 text-gray-500 border-b border-gray-200">
                            Order date
                          </td>
                          <td className="px-2 py-1.5 font-semibold text-gray-800 border-b border-gray-200 text-right">
                            {formatDate(freeze?.createdAt)}
                          </td>
                        </tr>
                        <tr className="bg-gray-50">
                          <td className="px-2 py-1.5 text-gray-500 border-b border-gray-200">
                            Freeze status
                          </td>
                          <td className="px-2 py-1.5 font-semibold text-gray-800 border-b border-gray-200 text-right">
                            {String(status).toUpperCase()}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-2 py-1.5 text-gray-500 border-b border-gray-200">
                            Ticket status
                          </td>
                          <td className="px-2 py-1.5 font-semibold text-gray-800 border-b border-gray-200 text-right">
                            {String(ticketStatus).toUpperCase()}
                          </td>
                        </tr>
                        <tr>
                          <td className="px-2 py-1.5 text-gray-500">Payment</td>
                          <td className="px-2 py-1.5 text-right">
                            <span
                              className={`inline-block px-2 py-0.5 text-xs font-bold border ${paymentTone}`}
                            >
                              {paymentStatus}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
}
